export const menu = {
  input: {
    media: {
      label: 'Audio file IVR'
    },

    wrong: {
      label: 'Tidak valid'
    },

    select_file: 'Pilih file | Pilih file lainnya',

    timeout: {
      label: 'Waktu Respon'
    },

    action: {
      label: 'Klik Setuju'
    }
  },

  state: {
    init: {
      description:
        'Menu suara IVR adalah elemen sirkuit yang memungkinkan Anda untuk secara fleksibel mengkonfigurasi logika perutean panggilan yang berbeda melalui interaksi dengan pelanggan'
    }
  }
};
